import React, { ReactElement, useEffect, useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Amplify, { Hub, Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
import { Login, Logout, SignUp, ForgotPassword, Profile, ResetPassword, ConfirmUser, Subscriptions, DeleteProfile } from './components/pages';

export default function App(): ReactElement {
  const [foundUser, setFoundUser] = useState<false | string>(false);

  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_SSO_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_SSO_COGNITO_USER_POOL_ID,
      /* identityPoolId: process.env.REACT_APP_SSO_COGNITO_IDENTITY_POOL_ID, */
      userPoolWebClientId: process.env.REACT_APP_SSO_COGNITO_CLIENT_ID,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      oauth: {
        domain: process.env.REACT_APP_SSO_COGNITO_DOMAIN,
        scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${process.env.REACT_APP_SSO_COGNITO_REDIRECT_URI}/profile`,
        redirectSignOut: process.env.REACT_APP_SSO_COGNITO_REDIRECT_URI,
        responseType: 'code',
      },
    },
  });

  Hub.listen('auth', ({ payload: { data } }) => {
    if (data !== null && !data.url) {
      let dataString = '';
      dataString = data.toString();
      if (dataString.includes('Already+found+an+entry+for+username+Google_')) {
        setFoundUser('Google');
      } else if (dataString.includes('Already+found+an+entry+for+username+Facebook_')) {
        setFoundUser('Facebook');
      } else if (dataString.includes('Already+found+an+entry+for+username+Apple_')) {
        setFoundUser('Apple');
      }
    }
  });

  useEffect(() => {
    switch (foundUser) {
      case 'Google':
        Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
        break;
      case 'Facebook':
        Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
        break;
      case 'Apple':
        Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Apple });
        break;
      default:
        break;
    }
  }, [foundUser]);

  return (
    <div className="App">
      <BrowserRouter>
        <div>
          <Switch>
            <Route path="/login" component={Login} />
            <Route exact path="/" component={Login} />
            <Route path="/register" component={SignUp} />
            <Route path="/confirm-user" component={ConfirmUser} />
            <Route path="/logout" component={Logout} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/profile" component={Profile} />
            <Route path="/subscriptions" component={Subscriptions} />
            <Route path="/delete-profile" component={DeleteProfile} />
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  );
}
